import { registerUser } from "../../../services/rest/users/userService";
import { getPayload } from "../../../utils/openPayloadToken";
import validateForm from "./Validate";

export const sendDataNewUser = async ({ setErrors, formValues }) => {
  try {
    const validationErrors = validateForm(formValues);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return { userData: undefined };
    } else {
      //   console.log("Datos a enviar(controlador):", formValues);
      const { token } = await registerUser(formValues);
      const userData = getPayload(token);
      setErrors({});
      return { userData, token };
    }
  } catch (error) {
    throw error;
  }
};
